import { SubmittedFormModel } from "app/services/api/types/forms/models/SubmittedFormModel";
import { FormStatusEnum } from "app/services/api/types/forms/enums/FormStatusEnums";
import { Button, ButtonText } from "ui/gluestack/button";
import { useAssessmentEntryEdit } from "app/features/assessments/providers";

interface Props {
  entry: SubmittedFormModel;
  onPress?: () => void;
}

export function AssessmentEntryUpdateAction({ entry, onPress }: Props) {
  return (
    <Button action="secondary" onPress={onPress}>
      <ButtonText>Update entry</ButtonText>
    </Button>
  );
}
